/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import { historyLoader } from './actions';
import { HISTORY_LOADER_STATUS, HISTORY_TABLE_TOTAL_PAGES, LOADER_STATUS,PROFILE_INFO, RECO_HISTORY_DATA, REFRESH_TAB, SAVE_RECO_HISTORY_TABLE_PAGES, SET_DOCUMENTVIEW_CURRENT_PAGE, SET_DOCUMENTVIEW_TABLE_PAGES, VENDOR_LIST } from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  vendorList:[],
  recoHistoryData: [],
  historyLoader: false,
  totalHistoryPages: 1,
  totalReconcileTablePages: 1,
  totalDocumentViewTablePages: 1,
  documentViewCurrentPageNumber: 1,
  isRefresh:true,
};

/* eslint-disable default-case, no-param-reassign */
const gstr6aReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case VENDOR_LIST:
        return {
          ...state,
          vendorList:action.vendorList
        }
      case RECO_HISTORY_DATA:
        return {
          ...state,
          recoHistoryData:action.data
        }
      case HISTORY_LOADER_STATUS:
        return {
          ...state,
          historyLoader:action.loaderStatus
        }
      case HISTORY_TABLE_TOTAL_PAGES:
        return {
          ...state,
          totalHistoryPages:action.pages
        }
      case SAVE_RECO_HISTORY_TABLE_PAGES:
        return {
          ...state,
          totalReconcileTablePages:action.pages
        }
      case SET_DOCUMENTVIEW_TABLE_PAGES:
        return {
          ...state,
          totalDocumentViewTablePages:action.pages
        }
      case SET_DOCUMENTVIEW_CURRENT_PAGE:
        return {
          ...state,
          documentViewCurrentPageNumber:action.pageNumber
        }
      case REFRESH_TAB:
        return {
          ...state,
          isRefresh:action.refresh
        }
      default:
        return state;
    }
  };

export default gstr6aReducer;
